<template>
    <div>
        <validation-observer v-slot="{ invalid, handleSubmit }" ref="feedbackValidator" v-if="features.canEdit()">
            <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

                <base-input class="mb-3"
                    name="description"
                    :error="errors.get('description')"
                >
                    <textarea class="form-control" rows="25"
                        :placeholder="$t('dashboard.comment')"
                        v-model="value.description"
                    ></textarea>
                </base-input>

                <!--
                <div class="category form-category mb-4">
                    <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
                </div>
                -->

                <div class="text-center">
                    <base-button native-type="submit"
                        type="primary"
                        :disabled="errors.any() || invalid"
                    >
                        {{ $t('common.save') }}
                    </base-button>

                    <base-button type="link" class="ml-auto" @click="modal.show = false">
                        {{ $t('common.cancel') }}
                    </base-button>
                </div>

            </form>
        </validation-observer>

         <div class="pb-3" v-else>
            <!-- Keep it on the same line -->
            <div class="description" v-if="value.description && value.description.trim().length > 0">{{value.description}}</div>
            <div v-else>
                {{ $t('dashboard.no-comment') }}
            </div>
         </div>
    </div>
</template>

<script>
    export default {
        
        props: {

            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },

            modal: {
                type: Object,
                required: true
            },

            features: {
                default: null
            },
        },

        created() {
            this.errors.setValidator('feedbackValidator', this)
        },

        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>

<style lang="css" scoped>
    .description {
        white-space: pre-wrap;
    }
</style>
